import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import VersionUpdateBanner from './components/ui/VersionUpdateBanner';
import AppProvider from './hooks';
import Routes from './routes';

//if (import.meta.env.NODE_ENV === 'development'){
//    makeServer();
//}

const queryClient = new QueryClient();


const App: React.FC = () => (
    <Router>
        <QueryClientProvider client={queryClient}>
            <AppProvider>
                <VersionUpdateBanner />
                <Routes />
            </AppProvider>
            <ReactQueryDevtools />
        </QueryClientProvider>
    </Router>
);

export default App;
